import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

import Typography from '@mui/material/Typography';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import QCheckbox from 'components/QCheckbox';
import QTip from 'components/QuickenControls/QTip';

import { styles } from './styles';


const useStyles = makeStyles()(styles as Record<string, any>);

interface CategoryMenuHeaderProps {
  checked: boolean;
  boxClick: () => void;
  payee: string;
}

/*
 CATEGORY MENU HEADER (QUICKEN ONLY) - this is the addition to the category field
 */
const CategoryMenuHeader: FC<CategoryMenuHeaderProps> = ({ boxClick, checked, payee }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.headerContainer}>
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <QCheckbox
          onClick={boxClick}
          checked={checked}
          classes={{ boxBorder: classes.headerCheckboxBorder, root: classes.headerCheckbox }}
        />
        <Typography variant={'body1'} pr={0.4}>
          Apply changes to similar transactions
        </Typography>
        <QTip
          title={'Quicken will look forwards and backwards in ' +
          `your transaction list and update all transactions with the payee name "${payee}" to use the ` +
          'selected category.  Additionally, this "rule" will be applied going forward to downloaded transactions'}
        >
          <HelpOutlineIcon
            className={classes.helpIcon}
          />
        </QTip>
      </div>
    </div>
  );
};

export default CategoryMenuHeader;
